import moment from "moment"
import store from '@/store/index'
import PapelSegurancaLoteItensService from "../../services/PapelSeguranca/PapelSegurancaLoteItensService"

class PapelSegurancaLoteItem {
  constructor (data) {
    this.papel_seguranca_lote_item_id = null
    this.papel_seguranca_lote_id = null
    this.registro_id = null
    this.ordem_servico_id = null
    this.status = null
    this.numero_serie = null
    this.usuario_id = null
    this.tipo_uso = null
    this.data_informado_ws = null
    this.data_cancelamento = null
    this.motivo_cancelamento = null
    this.created_at = null
    this.updated_at = null
    
    if (data) {
      Object.assign(this, data)
    }
  }

  async consumir (item, tipoUso = 'OS', registro_id = null, reimprimir = null) {
    const payload  = {
      cartorio_id: store.state.auth.usuario.cartorio_id,
      usuario_id: store.state.auth.usuario.user_id,

      papel_seguranca_lote_item_id: this.papel_seguranca_lote_item_id,
      tipo_papel: item.custa.tipoImpresso.value,
      numero_serie: this.numero_serie && this.numero_serie.toUpperCase(),
      data_consumo: moment().format('YYYY-MM-DD HH:mm:ss'),
      tipo_uso: tipoUso,

      registro_id: registro_id,
      ordem_servico_id: item.ordem_servico_id,
    } 
    try {
      const consumo = await PapelSegurancaLoteItensService.consume(payload)
      return consumo
    } catch (error) {
      const message = getErrors(error)
      return displayMessage('error', 'Erro!', message.message.split('"').join(''))
    }
  }
}

export default PapelSegurancaLoteItem